import React from 'react';
// This component is needed in order to apply gradients to SVG icons
export const SvgGradients = ()=>/*#__PURE__*/ React.createElement("svg", {
        height: "0",
        width: "0",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ac",
        x1: "0%",
        x2: "100%",
        y1: "38%",
        y2: "62%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "27.18%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ac-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ac-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ai",
        x1: "0%",
        x2: "100%",
        y1: "38.1%",
        y2: "61.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "27.18%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ai-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ai-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "brand",
        x1: "0%",
        x2: "100%",
        y1: "28%",
        y2: "72%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "24.14%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-brand-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "105.44%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-brand-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ce",
        x1: "100%",
        x2: "0%",
        y1: "65%",
        y2: "35%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ce-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ce-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "cyber",
        x1: "100%",
        x2: "0%",
        y1: "65%",
        y2: "35%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-cyber-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-cyber-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "data",
        x1: "100%",
        x2: "0%",
        y1: "62%",
        y2: "38%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-data-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "96.5%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-data-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "de",
        x1: "100%",
        x2: "0%",
        y1: "65%",
        y2: "35%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-de-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-de-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "dv",
        x1: "0%",
        x2: "100%",
        y1: "35%",
        y2: "65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-dv-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-dv-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "interactive",
        x1: "0%",
        x2: "100%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "-7.48%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-interactive-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "113.27%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-interactive-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "mk",
        x1: "0%",
        x2: "100%",
        y1: "35%",
        y2: "65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-mk-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-mk-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ml",
        x1: "0%",
        x2: "100%",
        y1: "35%",
        y2: "65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ml-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ml-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "pm",
        x1: "100%",
        x2: "0%",
        y1: "65%",
        y2: "35%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-pm-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.67%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-pm-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "ux",
        x1: "0%",
        x2: "100%",
        y1: "38%",
        y2: "62%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "27.18%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ux-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-ux-1)',
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "web",
        x1: "0%",
        x2: "100%",
        y1: "35%",
        y2: "65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "17.93%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-web-0)',
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92.3%",
        style: {
            stopColor: 'var(--chakra-colors-gradient-web-1)',
            stopOpacity: 1
        }
    }))));

//# sourceMappingURL=svg-gradients.js.map